import { render, staticRenderFns } from "./ResourcesSection.vue?vue&type=template&id=0077d966&"
import script from "./ResourcesSection.vue?vue&type=script&lang=ts&"
export * from "./ResourcesSection.vue?vue&type=script&lang=ts&"
import style0 from "./ResourcesSection.vue?vue&type=style&index=0&id=0077d966&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ResourcesItem: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/resources/ResourcesItem.vue').default})
